import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services";
import { BeatLoader } from "react-spinners";

export default function LoginForm() {
    const [userid, setUserid] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        try {
            const result = await login({ userid, password });
            if (result.success) {
                navigate("/dashboard");
            } else {
                setError(result.error || "Login failed. Please try again.");
            }
        } catch (err) {
            setError("An unexpected error occurred. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="bg-background flex flex-col items-center justify-center h-screen w-full">
            <div className="flex flex-col items-center justify-center w-[70vh] p-6 border border-white rounded-lg">
                <h1 className="text-3xl font-bold mb-4 text-white">Login</h1>
                {error && (
                    <div className="w-full p-2 mb-4 text-red-500 text-sm text-center">
                        {error}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="w-full">
                    <input
                        type="text"
                        placeholder="User ID"
                        value={userid}
                        onChange={(e) => setUserid(e.target.value)}
                        className="w-full p-2 mb-4 bg-transparent text-white text-sm border border-white rounded-lg"
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full p-2 mb-4 bg-transparent text-white text-sm border border-white rounded-lg"
                        required
                    />

                    {isLoading ? (
                        <div className="w-full flex items-center justify-center"><BeatLoader color="#FFFFFF" /></div>) : (
                        <button
                        type="submit"
                        disabled={isLoading}
                        className={`w-full px-4 py-2 text-black text-xl rounded-lg font-bold ${
                            isLoading ? "bg-gray-400" : "bg-white hover:bg-gray-200"
                        }`}
                    >
                        Login
                    </button>
                    )}
                </form>
            </div>
        </div>
    );
}